<template>
  <div id="dashboard-page">
    <b-card class="mb-5">
      <b-row>
        <b-col md="10">
          <h3>{{$route.name}}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <!-- <b-col md="2 mt-3">
          <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
        </b-col> -->
      </b-row>
      <div class="border-bottom mb-5"></div>
      <!-- <b-row>
        <b-col md="12">
          <b-row class="mb-3">
            <b-col md="3">
              <b-form-input :placeholder="'Search By Plate Number'" v-model="tableFilter.plate" customQueryParamName="search" />
            </b-col>
          </b-row>
        </b-col>  
      </b-row> -->
      <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-show-route-path="'#/vehicle/insurance-detail'" :can-edit-modal="false" :can-edit="false" :can-reject="false" :can-approve="false" :can-paid="false" :data-url="apiUrl.insurance" :data-key="dataKey" :data-columns="columns" :data-params="['plate']">
      </paginated-table>
      <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
    </b-card>
  </div>
</template>

<script>
  import PaginatedTable from '@/components/PaginatedTable'
  export default {
    components: {
      PaginatedTable
    },
    data: function() {
      var currentDate = new Date();
      var monthlymonth = new Date(currentDate)
      var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
      var twoDigitFirstDate= ("0" + (currentDate.getDate() + 0)).slice(-2);
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

      var currentDate = new Date();
      var monthly = new Date(currentDate)
      var thismonth = ("0" + (monthlymonth.getMonth() + 4)).slice(-2);
      var thistoday = ("0" + (monthly.getDate() + 0)).slice(-2);
      var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + thistoday;
      
      return {
        dataKey: 'vehicleBillInfo',
        apiUrl: {
          insurance: window.AppConfig.apiUrl + 'vehicle-bill-info?type=Insurance&start_due_date=' + createdDateTo + '&end_due_date=' + thismonthday + '&status=New',
          exportInsurance: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        columns: [
          // {
          //   label: 'Road Tax No.',
          //   key: 'billNumber',
          //   sortable: false
          // },
          {
            key: 'vehiclePlate',
            label: 'Plate',
            sortable: false
          },
          {
            label: 'Insurance Date',
            key: 'typeDate',
            sortable: false
          },
          {
            key: 'amounts',
            label: 'Amount',
            sortable: false
          },
          {
            key: 'paidDateVehicle',
            label: 'Paid Date',
            sortable: false
          },
          {
            key: 'note',
            label: 'Note',
            sortable: false
          },
          {
            key: 'statusType',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: '',
            sortable: false
          }
        ],
        tableFilter: {
          plate: this.$route.query.plate
        }
      }
    },
    watch: {
      'tableFilter.plate'() {
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.tableFilter.plate = this.tableFilter.plate
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      doExportToExcel () {
        let url = this.apiUrl.exportInsurance + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Insurance'
        
        window.open(url)
      },
      goBack () {
        window.goBack(this)
      },
    }
  }
</script>